import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../../common/http/http-provider.service';

@Injectable()
export class MasterDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }

  getOwnerTypes() {
    return this.get('masters/getAllOwnerTypes'); //d
  }
  // getFrameMaterials(frameId: number) {
  //   return new Promise<any>((resolve) => {
  //     this.get<any>('masters/getAllFrameMaterials?frameId=' + frameId)
  //       .subscribe((data: any) => {
  //         var result = data.value;
  //         resolve(result);
  //       },
  //         (error) => {
  //           resolve({});
  //         });
  //   });
  // }

  getFrameMaterials(frameId: number | number[]) {
  return new Promise<any>((resolve) => {
    let url: string;

    if (Array.isArray(frameId)) {
      // Multiple IDs → build query string with repeated frameId params
      const params = frameId.map(id => `frameId=${id}`).join('&');
      url = `masters/getAllFrameMaterials?${params}`;
    } else {
      // Single ID → keep old behavior
      url = `masters/getAllFrameMaterials?frameId=${frameId}`;
    }

    this.get<any>(url).subscribe(
      (data: any) => {
        const result = data.value;
        resolve(result);
      },
      (error) => {
        resolve({});
      }
    );
  });
}
  getFrameSysSuppliers() {
    return this.get('frameSysSupplier');
  }
  // getFrameNames(partner: number) {
  //   return this.get('masters/getAllFramesByPartnerId?partnerId=' + partner); //d
  // }
  getFrameNames(partner: number | number[]) {
  if (Array.isArray(partner)) {
    // Multiple IDs → build query string with repeated partnerId params
    const params = partner.map(id => `partnerId=${id}`).join('&');
    return this.get(`masters/getAllFramesByPartnerId?${params}`);
  } else {
    // Single ID → keep old behavior
    return this.get(`masters/getAllFramesByPartnerId?partnerId=${partner}`);
  }
}
  getAllFrames() {
    return this.get('masters/getAllFrames');
  }
  getAllMaterials() {
    return this.get('masters/getAllMaterials'); 
  }
  getFrame_Partner() {
    return this.get('masters/getFrame_Partner');
  }
  getFrame_Material() {
    return this.get('masters/getFrame_Material');
  }
  getFrameBeadPos() {
    return this.get('masters/GetFrameBeadPos');
  }
  getGlassTypes() {
    return this.get('masters/getAllGlassTypes'); //d
  }
  getGlassUnits() {
    return this.get('masters/getAllGlassUnits'); //d
  }
  getGlassCoatingCodes() {
    return this.get('masters/getAllGlassCoatingCodes'); //d
  }
  getGlassManufacturers() {
    return this.get('masters/getAllGlassManf'); //d
  }
  getCEMountingDirection() {
    return this.get('masters/getAllElementMountingDirec');
  }
  getCEAngle() {
    return this.get('masters/getAllElementAngle');
  }
  getCEType() {
    return this.get('masters/getAllElementTypes'); //d
  }
  getCostItemTypes() {
    return this.get('masters/getAllCostType');
  }
  getProjectCost() {
    return this.get('projectCost');
  }
  getPartner() {
    return this.get('masters/getAllPartners'); //d
  }

  getPartnerByType(typeId: number) {
    return this.get('masters/GetPartnersByType?id=' + typeId); //d
  }
  getOrganisationalUnits() {
    return this.get('masters/getAllOrganisationalUnits'); //d
  }
  getMyOrganisationalUnits() {
    return this.get('masters/getMyOrganisationalUnits'); //d
  }
  getPurpose() {
    return this.get('masters/getAllPurposes'); //d
  }
  getProjects() {
    return this.get('projects');
  }
  getCountryAndRegions() {
    return this.get('masters/getAllCountryReg');
  }

  GetAllCountryRegion() {
    return this.get('masters/GetAllCountryRegion');
  }
  getWorkgroup() {
    return this.get('masters/getAllWorkGrps'); //d
  }
  getConfidentiality() {
    // return this.get('masters/getAllConfidentialityLvls'); //d
    return this.get('confidentialityLevel/getAll');
  }
  getGroupview() {
    return this.get('masters/getAllGrpView'); //for prjdetails grpview
  }
  getUserByGroup(usrGroup: number, orgUnit: number) {
    return this.get('masters/getUserByGroup?id=' + usrGroup + '&org=' + 0);
  }
  getInstituteType() {
    return this.get('masters/getAllInstituteTypes'); //d
  }
  getTestPurpose() {
    return this.get('masters/getAllTestPurposes'); //d
  }
  getSupConstruction() {
    return this.get('masters/GetSupportingConstruction'); //d
  }
  getMountingDirection() {
    return this.get('masters/getMountingDirection'); //d
  }
  getTestType() {
    return this.get('masters/getAllTestTypes'); //d
  }
  getStanardsByModule(module: number, type: number) {
    return this.get(
      'masters/getAllStandardsByModule?module=' + module + '&type=' + type
    );
  }
  getTstwitness() {
    return this.get('tstWitness');
  }
  getTstLabResponsible() {
    return this.get('tstLabResponsible');
  }
  getTstInstiteLocation() {
    return this.get('masters/getAllInstituteLocs'); //d
  }
  getInstiteLocByType(type: number) {
    return this.get('masters/getAllInstituteLocs/' + type); //d
  }
  getInstiteLocByTest(testId: number) {
    return this.get('masters/getAllInstituteLocs?Id=' + testId); //d
  }
  getInstituteLoc(includeInactive: boolean) {
    return this.get('masters/getInstituteLocs?includeInactive=' + includeInactive, undefined, {
    headers: new HttpHeaders({ 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' })
    });
  }
  getTstSponsors() {
    return this.get('tstSponsors');
  }
  getTstInstaller() {
    return this.get('tstInstaller');
  }
  getTstReason() {
    return this.get('masters/failureReason');
  }
  getTstValidate() {
    return this.get('tstValidate');
  }
  getCertificateType() {
    return this.get('masters/getAllCerTypes');
  }
  getWorkGrpByOU(id: number) {
    return this.get('masters/getWorkGrpByOU/' + id);
  }
  getElementList(module: number, entity: number) {
    return this.get(
      'constructionElement/getTemplateListByModule?module=' + module + '&entity=' + entity
    );
  }
  getProjectList() {
    return this.get('project/GetProjectList');
  }

  getProjectNumberList(){
    return this.get('masters/GetProjectNumberList');
  }
  getGetMyOpenProject() {
    return this.get('project/GetMyOpenProjects');
  }

  getTestList(projectId: Number) {
    return this.get('test/GetTestList/' + projectId);
  }

  getCertificateList(id: Number) {
    return this.get('certificate/GetCertificateList/' + id);
  }
  getPerformanCriterian(module: number, entityId: number) {
    return this.get('constructionElement/getPerformanCriterion?module=' + module + '&type=' + entityId);
  }
  getGlassBehavior() {
    return this.get('masters/GlassBehavior');
  }
  getGlassBehaviorTest(testTypeId?: number) {
    let url = 'masters/GlassBehaviorTest';
    if (testTypeId != null && testTypeId > 0) {
      url += '?testTypeId=' + testTypeId;
    }
    return this.get(url);
  }
  getComponentCausedFailure() {
    return this.get('masters/ComponentCausedFailure');
  }
  getPrjStatus() {
    return this.get('status/getAll');
  }
  getSystemNumbers(query: string) {
    return this.get('masters/SystemNumbers/' + query);
  }
  getSystemNumbersWithLabel(query: string) {
    return this.get('masters/GetAllSysNumbersWithUseLabel/' + query);
  }
  getResultUnit() {
    return this.get(`masters/ResultUnit`);
  }
  getSupportingConstruction() {
    return this.get(`supportingConstruction/getAll`);
  }

  export(masterName: string) {
    return this.getFile<Blob>(`masters/export/${masterName}`, {});
  }
}
